import { type BranchKey, STANDARD_BRANCH } from '@festina-life/api'
import { CircularSpinner } from '@festina-life/ui/feedback'
import { withSuspense } from '@festina-life/ui/libs'

import { OperationsProvider } from '../../../workspace/OperationsProvider'
import { ConfigurationBranchStatus } from '../../branchNameWithStatus/ConfigurationBranchStatus'
import { StandardBranchStatus } from '../../branchNameWithStatus/StandardBranchStatus'
import { DetailsPanel } from '../../detailsPanel/DetailsPanel'
import { BranchLoadingStatusAndOperationCount } from '../branchesTree/BranchLoadingStatusAndOperationCount'
import { BranchDetailsTabs } from './BranchDetailsTabs'

type Props = {
  branchKey: BranchKey
  onClose: () => void
}

const BranchDetailsPanelInternal = ({ branchKey, onClose }: Props) => (
  <OperationsProvider
    branchKey={branchKey}
    isDisabledChangesetsRelevant={false}
    workspaceKey={undefined}
  >
    <DetailsPanel
      onClose={onClose}
      header={
        <>
          <span className="text-gray-500 dark:text-gray-400">
            {branchKey.server}
          </span>
          {branchKey.name === STANDARD_BRANCH ? (
            <StandardBranchStatus server={branchKey.server} />
          ) : (
            <ConfigurationBranchStatus branchKey={branchKey} />
          )}
        </>
      }
      status={<BranchLoadingStatusAndOperationCount branchKey={branchKey} />}
    >
      <BranchDetailsTabs branchKey={branchKey} />
    </DetailsPanel>
  </OperationsProvider>
)

export const BranchDetailsPanel = withSuspense(BranchDetailsPanelInternal, {
  fallback: <CircularSpinner className="mx-auto my-2 size-8" />,
})
